import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import iconImage from "../icon.png";
import "./Navbar.css";

/**
 * Glass top bar.
 *
 * `links` is built by the layout from the signed-in user's role, so this
 * component stays role-agnostic: it renders whatever it is handed, in the
 * desktop bar and in the mobile drawer, and never decides visibility itself.
 */
export default function Navbar({ links, homeTo = "/" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  const handleLogout = () => {
    close();
    logout();
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    const onResize = () => {
      if (window.innerWidth > 900) setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("resize", onResize);
      document.body.style.overflow = "";
    };
  }, [open]);

  const linkClass = ({ isActive }) => (isActive ? "nav-link active" : "nav-link");

  const userBadge = (
    <div className="nav-user-badge">
      <span className="nav-user-name">{user?.username}</span>
      {user?.role && <span className="nav-user-role">{user.role}</span>}
    </div>
  );

  return (
    <nav className="navbar" aria-label="Principal">
      <div className="nav-left">
        <NavLink to={homeTo} className="nav-brand" aria-label="Início">
          <img src={iconImage} alt="" className="nav-icon" />
        </NavLink>
        <div className="nav-desktop-links">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="nav-right">
        {userBadge}
        <button
          type="button"
          className="gc-btn nav-logout-btn"
          onClick={handleLogout}
        >
          Sair
        </button>
      </div>
      <button
        type="button"
        className={`nav-burger${open ? " open" : ""}`}
        aria-label={open ? "Fechar menu" : "Abrir menu"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>
      <div className={`nav-overlay${open ? " open" : ""}`} onClick={close} />
      <div
        className={`nav-drawer${open ? " open" : ""}`}
        role="dialog"
        aria-label="Menu"
        aria-hidden={!open}
      >
        <div className="nav-drawer-header">{userBadge}</div>
        <div className="nav-drawer-links">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} onClick={close}>
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="nav-drawer-footer">
          <button
            type="button"
            className="gc-btn nav-logout-btn"
            onClick={handleLogout}
          >
            Sair
          </button>
        </div>
      </div>
    </nav>
  );
}
